import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 18l.01 0","key":"svg-0"}]]

const IconWifi0 = createReactComponent('outline', 'wifi-0', 'Wifi0', __iconNode);

export default IconWifi0;